import { Box, Button, Flex, Heading, Image, Link, Text, useMediaQuery } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import Slider from 'react-slick';
import { theme } from '../../../assets/style/theme';
import SlideArrow from '../../../Component/Button/SlideArrow';
import { getBoardList } from '../../../service';
import { ShesViewBannerSection } from './style';

type Props = {
};

function ParticipationContentItemShesView({  }: Props) {

  const { isLoading:isLoadingList, error:listError, data:list } = useQuery('BoardListShesView', () => getBoardList('33', 999, 0, ''));

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const workBannerSetting = {
		infinite: true,
		// centerMode: true,
		speed: 500,
		slidesToShow: isMobile ? 1 : 4,
		slidesToScroll: 1,
		nextArrow: <SlideArrow color="gr" />,
		prevArrow: <SlideArrow color="gr" />,
		// variableWidth: true,
		// variableHeight: true,
	};

  const boxStyle = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#e6e6e6',
    width: isMobile ? '100%' : '282px',
    borderRadius: '24px',
    marginRight: '32px;',
    overflow: 'hidden',
  }

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
      <Box pt="20" pb="10">
        <Heading size="3xl" color="b.dgr" >이전 호 보기</Heading>
      </Box>
      {
        !isLoadingList && !listError && (
          <>
          <ShesViewBannerSection>
          <Slider {...workBannerSetting}>
            {list.items.map((item: any, index: number) => (
              <div key={index}>
                <Box {...boxStyle} className="item">
                  <Link href={`/board?mode=view&board_id=33&post_id=${item.uid}`}>
                  <Image src={`https://koreashe.org${item.thumbnail_file}`} objectFit="cover" className="item-image" />
                    <Box padding="6" className="item-text">
                      <Flex justify="space-between" direction="column">
                        <Text fontSize="lg" color="b.g" lineHeight="1.4" fontWeight="bold">
                          {item.title}
                        </Text>
                      </Flex>
                    </Box>
                  </Link>
                </Box>
              </div>
            ))}
          </Slider>
          </ShesViewBannerSection>
          <Box textAlign="center" pt="10">
            <Link href="/board?board_id=33"><Button colorScheme="dgr" size="lg">{ isEnglish ? 'View All' : '전체보기' }</Button></Link>
          </Box>
          </>
        )
      }
    </>
  );
}

ParticipationContentItemShesView.defaultProps = {
};

export default ParticipationContentItemShesView;
